import getSocket from 'services/getSocket';

let socket;

const handleOn = (name, callback) => {
  return (
    socket &&
    socket.on(name, data => {
      callback(data);
    })
  );
};

const on = (name, callback) => {
  if (Array.isArray(name)) {
    return name.map(n => handleOn(n, callback));
  }

  return handleOn(name, callback);
};

const off = (name, callback) => {
  if (!socket) return;
  if (Array.isArray(name)) {
    name.forEach(n => socket.off(n, callback));
  } else {
    socket.off(name, callback);
  }
};

const emit = (name, data) => {
  // console.log('WS emit:', name, data);
  return socket && socket.emit(name, data);
};

const disconnect = () => {
  if (socket) {
    socket.disconnect();
  }
};

const isConnected = () => {
  return !!socket?.connected;
};

let listenerSetup = null;

const setListenerSetup = fn => {
  listenerSetup = fn;
};

const connect = () => {
  if (socket) {
    socket.disconnect();
  }
  socket = getSocket();
  if (typeof listenerSetup === 'function') {
    listenerSetup();
  }
  // Socket auto-connects by default
};

const initialized = () => !!socket;

export default {
  connect,
  disconnect,
  emit,
  initialized,
  isConnected,
  on,
  off,
  setListenerSetup,
};
